import React, {Component} from 'react'
import {Button, Input, message, notification, Popover} from 'antd'
import PropTypes from 'prop-types'
import {updateNoteLabel} from "../../../../../services/api/labelApi"

class LabelNote extends Component {
    state = {
        visible: false,
        note: this.props.note,
    }

    _tempNote = this.props.note

    _hidePopover = () => {
        this.setState({
            visible: false,
        })
    }

    _handleVisibleChange = visible => {
        this.setState({
            visible,
        })
    }

    _handleChangeInput = e => {
        const {value} = e.target

        this._tempNote = value
    }

    _requestUpdateNote = async () => {
        try {
            const {labelId} = this.props
            const payload = {
                note: this._tempNote,
            }

            const {data: response} = await updateNoteLabel(labelId, payload)

            const {success, error} = response

            if (!success) {
                throw new Error(error)
            }

            this.setState({
                note: this._tempNote,
            })

            message.success('Đã lưu note')
        } catch (e) {
            notification.error({
                message: 'ERROR',
                description: e.message,
                duration: 0,
            })
        } finally {
            this._hidePopover()
        }
    }

    render() {
        const {visible, note} = this.state

        const content = (
            <div>
                {
                    visible && <Input.TextArea defaultValue={note} autoSize={{minRows: 3, maxRows: 5}}
                                               onChange={this._handleChangeInput}/>
                }

                <div className='d-flex justify-content-end mt-1'>
                    <Button type='link' size='small' onClick={this._requestUpdateNote}>Lưu</Button>
                </div>
            </div>
        )

        return (
            <td className='LabelNote'>
                <div className='Content d-inline-block'>
                    {note}
                </div>

                <Popover visible={visible} onVisibleChange={this._handleVisibleChange} title='Note' content={content}
                         placement='bottom'
                         trigger='click'>
                    <Button type='link' icon='edit'/>
                </Popover>
            </td>
        )
    }
}

LabelNote.defaultProps = {
    note: '',
}

LabelNote.propTypes = {
    labelId: PropTypes.string.isRequired,
    note: PropTypes.string,
}

export default LabelNote
